/**
 * Handles show/hide functionality for content loaded from legacy CodeIgniter views
 * into the Laravel application. This module specifically manages the behavior of
 * expandable/collapsible content blocks that originate from the CodeIgniter portion
 * of the application.
 *
 * @todo TODO: [After launch] For new Laravel-native implementations, create an AlpineJS expandable-text component
 * in resources/views/components/gigsalad/expandable-text.js
 *
 * @deprecated This module handles show/hide functionality specifically for legacy CodeIgniter markup.
 * For new Laravel implementations, use AlpineJS expandable-text component instead.
 */
export default class LegacyShowHide {
	constructor() {
		document.addEventListener('click', (e) => {
			const trigger = e.target.closest('.js-show');
			if (!trigger) return;

			e.preventDefault();
			this.handleToggle(trigger);
		});
	}

	handleToggle(trigger) {
		// Extract data attributes for toggle behavior
		const showId = trigger.dataset.jsShowId;
		const showText = trigger.dataset.jsShowText;
		const hideText = trigger.dataset.jsHideText;

		let target;

		// Find target element either by ID or container relationship
		if (showId) {
			target = document.getElementById(showId);
		} else {
			target = trigger.closest('.js-show-container')?.querySelector('.js-hide');
		}

		if (!target) return;

		const isHidden = target.classList.contains('js-hide');

		if (isHidden) {
			// Show content with animation
			target.style.display = 'none';
			target.classList.remove('js-hide');
			this.slideDown(target, () => {
				target.dispatchEvent(new CustomEvent('displayComplete'));
				// Enable form inputs when content is visible
				if (showId) {
					target.querySelectorAll('input, select, textarea, button').forEach((input) => input.removeAttribute('tabindex'));
				}
			});
		} else {
			// Hide content with animation
			this.slideUp(target, () => {
				target.classList.add('js-hide');
				target.style.display = 'block';
				target.dispatchEvent(new CustomEvent('displayComplete'));
				// Disable form inputs when content is hidden
				if (showId) {
					target.querySelectorAll('input, select, textarea, button').forEach((input) => input.setAttribute('tabindex', '-1'));
				}
			});
		}

		// Update trigger button state
		trigger.classList.toggle('drop-enabled');

		// Handle text toggle states for different use cases
		if (trigger.textContent.trim() === 'Less') {
			trigger.textContent = 'More';
			trigger.classList.replace('toggle-link--less', 'toggle-link--more');
		} else if (trigger.textContent.trim() === 'More') {
			trigger.textContent = 'Less';
			trigger.classList.replace('toggle-link--more', 'toggle-link--less');
		} else if (trigger.innerHTML === showText) {
			trigger.innerHTML = hideText;
		} else if (trigger.innerHTML === hideText) {
			trigger.innerHTML = showText;
		}
	}

	// Slide down animation with height transition
	slideDown(element, callback) {
		element.style.display = 'block';
		const height = element.scrollHeight;
		element.style.overflow = 'hidden';
		element.style.height = 0;
		element.style.transition = 'height 200ms ease';

		requestAnimationFrame(() => {
			element.style.height = `${height}px`;
			setTimeout(() => {
				// Clean up animation properties
				element.style.height = '';
				element.style.overflow = '';
				element.style.transition = '';
				if (callback) callback();
			}, 200);
		});
	}

	// Slide up animation with height transition
	slideUp(element, callback) {
		const height = element.scrollHeight;
		element.style.overflow = 'hidden';
		element.style.height = `${height}px`;
		element.style.transition = 'height 200ms ease';

		requestAnimationFrame(() => {
			element.style.height = 0;
			setTimeout(() => {
				// Clean up animation properties
				element.style.display = 'none';
				element.style.height = '';
				element.style.overflow = '';
				element.style.transition = '';
				if (callback) callback();
			}, 200);
		});
	}
}
